<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout column fluid fill-height>
      <v-flex d-flex md12>
        <v-layout row fill-height>
          <v-flex d-flex md12>
            <dx-data-grid
                class="grid collapsable"
                :style="`width: 100%; height: 100%; max-height:${tableHeight}`"
                :data-source="usersSource"
                :remote-operations="true"
                :show-column-lines="true"
                :show-row-lines="true"
                :show-borders="true"
                :word-wrap-enabled="true"
                :row-alternation-enabled="false"
                :column-auto-width="true"
            >
              <DxColumn data-field="displayName" caption="Username"/>
              <DxColumn data-field="email" caption="Email"/>
              <DxColumn cell-template="rolesTemp" data-field="roles" caption="Roles"/>
              <DxColumn cell-template="actionsTemp" data-field="acctions" caption=""/>
              <div slot="rolesTemp" slot-scope="{data}">
                {{ data.row.data.roles.join(', ') }}
              </div>
              <div slot="actionsTemp" slot-scope="{data}">
                <ul class="actionBtnList">
                  <li>
                    <v-btn flat class="actionBtn" @click="editUser(data.row.data)">
                      <font-awesome-icon icon="pen" style="color:rgb(51,82,128);"/>
                    </v-btn>
                  </li>
                  <li>
                    <v-btn flat class="actionBtn" @click="deleteUser(data.row.data)">
                      <font-awesome-icon icon="trash" style="color:rgb(51,82,128);"/>
                    </v-btn>
                  </li>
                </ul>
              </div>
            </dx-data-grid>
          </v-flex>
        </v-layout>
        <v-dialog v-model="showNewUserDialog" width="840" height="640" scrollable>
          <v-card style="width:100%;height:420px;">
            <v-card-title primary class="title" style="height:10%;">{{ ( userId? 'Edit' : 'New' ) }} WinGD User</v-card-title>
            <v-card-media
                style="height:80%; max-height:80%; overflow-y:auto; padding: 0 16px; width: 100%"
            >
              <v-layout column>
                <v-flex d-flex md1>
                  <v-layout row>
                    <v-flex d-flex md6 style="padding: 0 8px;">
                      <v-text-field
                          v-model="email"
                          label="Email"
                      />
                    </v-flex>
                    <v-flex d-flex md6 style="padding: 0 8px;">
                      <v-text-field
                          v-model="password"
                          label="Password"
                          :append-icon="passShow ? 'visibility' : 'visibility_off'"
                          :type="passShow ? 'text' : 'password'"
                          @click:append="passShow = !passShow"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex d-flex md1>
                  <v-layout row>
                    <v-flex d-flex md6 style="padding: 0 8px;">
                      <v-text-field
                          v-model="firstname"
                          label="First name"
                      />
                    </v-flex>
                    <v-flex d-flex md6 style="padding: 0 8px;">
                      <v-text-field
                          v-model="lastname"
                          label="Last name"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex d-flex md1>
                  <v-layout row>
                    <v-flex d-flex md12 style="padding: 0 8px;">
                      <v-text-field
                          v-model="displayname"
                          label="Display name"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex d-flex md1>
                  <v-layout row>
                    <v-flex d-flex md12 style="padding: 0 8px;">
                      <v-select
                          :items="roles"
                          label="User Role"
                          v-model="userroles"
                          multiple="true"
                          style="height:100%; margin-top:15px; margin-bottom:5px; font-size:18px;"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-media>
            <v-card-actions style="height:10%;">
              <v-spacer/>
              <v-btn color="primary" flat @click="cancelNewUserDialog">Cancel</v-btn>
              <v-btn style="color:white; background-color: rgb(51,82,128);" @click="postUser">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showDeleteUserDialog" width="448" scrollable>
          <v-card style="width:100%;height:224px;">
            <v-card-title primary class="title" style="height:10%;">Delete WinGD User</v-card-title>
            <v-card-media
                style="overflow-y:auto; padding: 0 16px; width: 100%"
            >
              <p>
                You are about to delete user <b>{{ displayname || email }}</b>.
              </p>
            </v-card-media>
            <v-card-actions style="height:10%;">
              <v-spacer/>
              <v-btn color="primary" flat @click="cancelDeleteUserDialog">Cancel</v-btn>
              <v-btn style="color:white; background-color: rgb(51,82,128);" @click="sendDelete">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex d-flex md1>
        <v-layout row>
          <v-flex d-flex md1 style="padding-left: 0">
            <v-btn
                style="color:white; background-color: rgb(51,82,128);"
                @click="openNewUserDialog"
            >
              New User
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-alert
        outline
        dismissible
        class='alert'
        :value="alert"
        type="error"
        transition="scale-transition"
        color='rgb(205, 57, 64)'
        style="margin: auto; position: absolute; z-index: 1000"
        @input="closeAlert"
    >
      {{ alert_message }}
    </v-alert>
  </v-container>
</template>

<script>
import {DxDataGrid, DxColumn} from "devextreme-vue/data-grid";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {store} from "@/main";
import axios from "axios";

export default {
  name: "Users",
  components: {
    DxDataGrid,
    DxColumn
  },
  data() {
    return {
      userOptions: null,
      usersSource: null,
      showNewUserDialog: false,
      showDeleteUserDialog: false,
      userId: null,
      email: '',
      password: '',
      firstname: '',
      lastname: '',
      displayname: '',
      userroles: [],
      roles: [],
      tableHeight: '0px',
      passShow: false,
      alert_message: '',
      alert: false
    }
  },
  methods: {
    calculateTableHeight: function () {
      let height = (window.outerHeight / 12 * 10).toFixed(0);
      this.tableHeight = height + 'px';
    },
    setUsersSource: function () {
      this.usersSource = createStore({
        loadUrl: `${store.config.api_location}/users/`,
        loadMethod: 'POST',
        loadParams: {
          'company': 'wingd'
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {Authorization: store.userProfile.jwt};
        },
        onLoading: function (loadOptions) {
          this.userOptions = loadOptions;
        }
      })
    },
    openNewUserDialog: function () {
      this.showNewUserDialog = true;

      this.userId = null;
      this.email = '';
      this.password = '';
      this.firstname = '';
      this.lastname = '';
      this.displayname = '';
      this.userroles = [];
    },
    editUser: function (user) {
      this.showNewUserDialog = true;

      this.userId = user.id;
      this.email = user.email;
      this.firstname = user.firstname;
      this.lastname = user.lastname;
      this.displayname = user.displayName;
      this.userroles = user.roles;
    },
    deleteUser: function (user) {
      this.showDeleteUserDialog = true;

      this.userId = user.id;
      this.email = user.email;
      this.displayname = user.displayName;
    },
    cancelNewUserDialog: function () {
      this.showNewUserDialog = false;
    },
    cancelDeleteUserDialog: function () {
      this.showDeleteUserDialog = false;

      this.userId = null;
      this.email = '';
      this.displayname = '';
    },
    fetchUserRoles: function () {
      axios.get(store.config.api_location + '/users/roles/wingd')
          .then((response) => {
            this.roles = response.data.data.roles;
          })
          .catch(function () {
          });
    },
    postUser: function () {
      let isValid = this.email.length > 0,
          url = store.config.api_location + '/users/add/win gd';

      isValid = isValid && (this.password.length > 0 || this.userId != null);
      isValid = isValid && this.firstname.length > 0;
      isValid = isValid && this.lastname.length > 0;
      isValid = isValid && this.displayname.length > 0;
      isValid = isValid && this.userroles.length > 0;

      if (isValid) {
        let body = {
          "email": this.email,
          "firstname": this.firstname,
          "lastname": this.lastname,
          "display": this.displayname,
          "roles": this.userroles
        };

        if (this.userId == null) {
          body["password"] = this.password;
        } else {
          url = `${store.config.api_location}/users/update/${this.userId}`
        }

        axios.post(url, body, {headers: {Authorization: store.userProfile.jwt}})
            .then((response) => {
              if (response.data.success) {
                this.setUsersSource();
                this.showNewUserDialog = false
                this.showDeleteUserDialog = false
              } else {
                this.alert_message = response.data.msg;
                this.alert = true
              }
            })
            .catch(function () {
              this.setUsersSource();
              this.showNewUserDialog = false
              this.showDeleteUserDialog = false
            })
      }
    },
    sendDelete: function () {
      axios.get(`${store.config.api_location}/users/delete/${this.userId}`, {headers: {Authorization: store.userProfile.jwt}})
          .then((response) => {
          })
          .catch(function () {
          })
          .finally(() => {
            this.setUsersSource();
            this.showNewUserDialog = false
            this.showDeleteUserDialog = false
          });
    },
    closeAlert(v) {
      this.alert = false;
    }
  },
  mounted() {
    this.setUsersSource();
    this.calculateTableHeight();
    this.fetchUserRoles();
  }
}
</script>

<style scoped>
.actionBtnList {
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-flex;
}

.actionBtn {
  min-width: 20px;
  width: 20px;
  max-width: 20px;

  height: 20px;
  max-height: 20px;

  padding: 0;
}
</style>